import { CSSProperties, useRef } from 'react'
import { Transition } from 'react-transition-group'
import { CareerPathJobCardTone } from 'builder/components/CareerPathJobCard'
import * as Styles from './styles'

type Props = {
  tone?: CareerPathJobCardTone
  onConfirm: () => void
  isVisible: boolean
}

export const StickedButton = ({ isVisible = false, tone, onConfirm }: Props) => {
  const style = {
    '--color-accent': `var(--${tone}-50)`,
    '--color-accent-hover': `var(--${tone}-60)`,
  } as CSSProperties
  const transitionRef = useRef(null)
  return (
    <Transition in={isVisible} timeout={0} appear nodeRef={transitionRef}>
      {state => (
        <Styles.StickedButtonContainer
          transitionState={state}
          style={style}
          containerRef={transitionRef}
        >
          <Styles.ButtonConfirm onClick={onConfirm}>Confirm My Path</Styles.ButtonConfirm>
        </Styles.StickedButtonContainer>
      )}
    </Transition>
  )
}
